define.alias("shared/components/shared/ui/switcher/list", "preview-grid/components/shared/ui/switcher/list");